var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',_vm._b({staticClass:"app-bar"},'v-app-bar',_vm.currentNavBarVOptions,false),[(_vm.showMenuButton)?_c('v-app-bar-nav-icon',{on:{"click":_vm.handleClickMenu}}):_vm._e(),_c('v-spacer'),_c('UserMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }